import { lazy } from "react";

const routes = [
  {
    path: "/moduleOrgMapping",
    element: lazy(
      () => import("../../pages/ModulePersonalization/ModuleOrgMapping"),
    ),
  },
  {
    path: "/moduleOrgMapping/create",
    element: lazy(
      () =>
        import("../../pages/ModulePersonalization/ModuleOrgMapping/create-editModuleOrgMapping"),
    ),
  },
  {
    path: "/moduleOrgMapping/edit/:id",
    element: lazy(
      () =>
        import("../../pages/ModulePersonalization/ModuleOrgMapping/create-editModuleOrgMapping"),
    ),
  },
];

export default routes;
